export default __webpack_public_path__ + "images/layout1.png";